import { createContext, useContext, useState, type ReactNode } from "react";
import { useRevalidator } from "react-router-dom";

type PropertyTenancyContextValue = {
  propertyTenancyId: string;
  setPropertyTenancyId: (id: string) => void;
};

const PropertyTenancyContext = createContext<
  PropertyTenancyContextValue | undefined
>(undefined);

export function PropertyTenancyProvider({ children }: { children: ReactNode }) {
  const { revalidate } = useRevalidator();
  const [propertyTenancyId, setPropertyTenancyIdState] = useState(() => {
    return localStorage.getItem("property_tenancy_id") ?? "";
  });

  const setPropertyTenancyId = (id: string) => {
    localStorage.setItem("property_tenancy_id", id);
    setPropertyTenancyIdState(id);
    revalidate();
  };

  return (
    <PropertyTenancyContext.Provider
      value={{ propertyTenancyId, setPropertyTenancyId }}
    >
      {children}
    </PropertyTenancyContext.Provider>
  );
}

export function usePropertyTenancy() {
  const ctx = useContext(PropertyTenancyContext);
  if (!ctx) {
    throw new Error(
      "usePropertyTenancy must be used inside <PropertyTenancyProvider>",
    );
  }
  return ctx;
}
